module.exports = __webpack_public_path__ + "media/images/pla/pla24-efafe3878b2f9349e27117a114fc2517.jpg";